import { Fmulinje } from "../../../../interfaces/schema";
import { defaultIfNullish } from "../../../../util/stringUtil";
import ListItem from "../../../ListItem";
import { SidebarContainer } from "../../../SidebarContainer";

export default function Sidebar({ fmulinje }: { fmulinje: Fmulinje }) {
  return (
    <SidebarContainer>
      <ListItem label="Linjenummer" value={defaultIfNullish(fmulinje.nr)} />
      <ListItem
        label="Antal deltagere"
        value={defaultIfNullish(
          fmulinje.fmulinjeKursist.filter((p) => {
            return p.deltagerStatus === "TILMELDT";
          }).length,
        )}
      />
    </SidebarContainer>
  );
}
